import type {StoreType} from 'app/store/AppStore';

type HandlerSignatureType = (
  event: string,
  payload: {data: any},
  handler: (event: string) => void,
  store: StoreType | null
) => void;

export class WebSocketRouter {
  name: string;
  namespaces: Record<string, WebSocketRouter> = {};
  handlers: Record<string, HandlerSignatureType> = {};

  constructor(name: string, routers: Record<string, WebSocketRouter> = {}) {
    this.name = name;
    Object.keys(routers).forEach((namespace) => {
      const router = routers[namespace];
      this.register_router(namespace, router);
    });
  }

  register_router(namespace: string, router: WebSocketRouter) {
    this.namespaces[namespace] = router;
  }

  register_handler(event: string, func: HandlerSignatureType) {
    if (this.handlers[event] != null) {
      throw Error(
        `Handler for event "${event}" is already registered in "${this.name}" router`
      );
    }

    this.handlers[event] = func;
  }

  route(
    event: string,
    payload: any,
    sendMessage: (arg0: string) => void | null,
    store: StoreType | null
  ): boolean {
    const handler = this.handlers[event];

    if (handler != null) {
      handler(event, payload, sendMessage, store);
      return true;
    } else if (event.indexOf('.') >= 0) {
      const parts = event.split('.');
      const namespace = parts.shift() as string;
      event = parts.join('.');
      const subrouter = this.namespaces[namespace];

      if (subrouter != null) {
        return subrouter.route(event, payload, sendMessage, store);
      }
    }

    return false;
  }
}
